module.exports = __webpack_public_path__ + "img/header-weddingRingsTensionRings.994e0ca.webp";